import { UpdateTemplateMessage, UpdateTemplateMessageVariables } from './__generated__/UpdateTemplateMessage'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UpdateTemplateMessage($input: UpdateTemplateMessageInputV2!) {
    updateTemplateMessage: updateTemplateMessageV2(input: $input) {
      ... on TemplateMessageV2 {
        id
        isFeatured
        attribution
        categoryId
        created
        message {
          id
          characters
          text
        }
      }
      ... on TemplateMessageErrorV2 {
        type
        error
      }
    }
  }
`

export const useUpdateTemplateMessage = () =>
  useMutation<UpdateTemplateMessage, UpdateTemplateMessageVariables>(MUTATION)
